import { render } from "./Email.vue?vue&type=template&id=26fd09ce&ts=true"
import script from "./Email.vue?vue&type=script&lang=ts"
export * from "./Email.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__